import React from 'react';
import { styled } from '@mui/material/styles';
import { Backdrop, makeStyles, createStyles, Theme } from '@mui/material';
import './index.scss';

export type LoadingSectionProps = {
  open: boolean;
  message: string;
  onClick?: any;
  size?: string;
};

export const LoadingSection = ({
  open,
  onClick,
  message,
  size,
}: LoadingSectionProps): React.JSX.Element => {
  const StyledBackdrop = styled(Backdrop)(({ theme }) => ({
    zIndex: theme.zIndex.drawer + 1,
    color: '#fff',
  }));

  return (
    <div className={`loadingSection ${size || 'fullWindow'}`}>
      <StyledBackdrop open={open} onClick={onClick}>
        <div className="loading-container">
          <div className="loading-spinner">
            <div></div>
            <div></div>
            <div></div>
          </div>
          <div className="loading-text">{message}</div>
        </div>
      </StyledBackdrop>
    </div>
  );
};

export default LoadingSection;
